import React from 'react'

const Hero = () => {
  return (
    <div>
          <div>
        <h1 className='font-bold text-[10px] md:text-[36px] text-[#03897B]'>PURPOSE</h1>
      </div>

      {/* Image Container */}
      <div className="relative w-full h-[100px] md:h-[427px] rounded-t-[5px] overflow-hidden mt-1">
        {/* Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746285062/image_70_ihiigs.png"
          alt="Funding"
          className="w-full h-full object-cover"
        />

        {/* Logo */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014742/image_1717_1_mrc5cr.png"
          alt="Ad Luck Logo"
          className="absolute bottom-6 left-4 md:bottom-12 md:left-8 w-[80px] md:w-[174px]"
        />
      </div>

      {/* Bottom Bar */}
      <div className="w-full h-[30px] md:h-[78px] bg-[#e0e0e0] flex items-center justify-between px-4 md:px-6 font-bold text-sm rounded-b-[5px]">
        <span className='text-[10px] md:text-[24px]'>CREDIT SCORE</span>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014605/Expand_right_13_khjlok.png"
          alt="Arrow"
          className="h-[26px] w-[26px] md:h-[46px] md:w-[47px]"
        />
      </div>

      <div className='md:mt-4 md:mb-14 mt-5 mb-6'>
        <p className='md:text-[18px] text-[8px] font-normal'>
        Ad-Luck positions itself as a trusted intermediary for development partners, streamlining the disbursement of funds to ensure they reach targeted beneficiaries efficiently, transparently, and with measurable impact on community development. <br/>
        Entrepreneurs can access funding from development partners by registering through the Ad-Luck Holdings funding portal. Once registered, their applications are evaluated for compliance with funding criteria. Those who meet the requirements are then eligible to receive financial support.
        </p>
      </div>
   <div className='flex items-center md:space-x-6'>
   <a href='/funding'>
   <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>DUE DILIGENCE</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Due dilligence
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to  due diligence</p>

            </div>
   </a>
           <a href='/BusinessPlan'>
           <div>
      <p className='md:text-[20px] text-[8px]  font-bold md:mb-3'>BUSINESS PLANS</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Business plans
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to  business plans</p>

            </div>
           </a>
     <a href='/CreditScore'>
     <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>CREDIT SCORE</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Credit score
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to credit score</p>

            </div>
     </a>
           <a href='/LocationApplication'>
           <div>
      <p className='md:text-[20px] text-[8px]   font-bold md:mb-3'>FUNDING</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Loan Application
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to Funding</p>

            </div>
           </a>
   </div>
   <div className='md:mt-10  mt-5 md:mb-8 mb-3'>
   <h1 className='md:text-[24px] text-[10px] font-bold mb:mb-5'>CREDIT SCORE</h1>
        <p className='md:text-[18px] text-[6px] font-normal mt-2'>
        Ad-Lucks Credit Score System is a digital credit assessment tool designed to evaluate the creditworthiness of individuals and small businesses, particularly those in informal or underbanked sectors. It uses alternative data—such as mobile money transactions, business activity, and behavioral patterns—to generate a reliable credit score.<br/>
        This system helps financial institutions and service providers make informed lending decisions by providing a more inclusive, data-driven way to assess risk, especially for people without traditional credit histories..
        </p>
      </div>
    
      <div className="leading-[1.2] text-center md:mb-10">
        <h2 className="text-[10px] md:text-[28px] font-bold text-[#03897B]">
        CREDIT SCORE

        </h2>
        <p className="text-[10px] md:text-[24px] font-normal">
        View for funding applicant
        </p>
      </div>
      <div className="w-full md:mb-4 mb-2">
        <div className="relative">
          <input
            placeholder="Search"
            type="text"
            className="w-full md:h-[50px] h-[30px] text-[#979797] text-[10px] md:text-[16px] font-bold md:p-3 pr-10 p-1  md:px-6 px-3 border-[1px] border-[#C4C4C4] md:rounded-md  rounded-full focus:outline-none focus:ring-2 focus:ring-green-600"
          />
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
            alt="Search Icon"
            className="w-[18px] h-[15px] md:h-[24px] md:w-[24px] absolute right-5 top-1/2 transform -translate-y-1/2"
          />
        </div>
      </div>
    </div>
  )
}

export default Hero